import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const SchemaScript = loadable(() => import('./Schemas'));

const SeoTags = ({ type, seoData, meta, link, VAP }) => {
  const { title, description, keywords } = meta || {};
  const { rel, href } = link || {};

  return (
    <>
      <Helmet>
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {rel && href && <link rel={rel} href={href} />}
      </Helmet>
      {seoData && (href || VAP) && <SchemaScript type={type} seoData={seoData} />}
    </>
  );
};

SeoTags.propTypes = {
  type: PropTypes.oneOf(['', 'JobPosting', 'JobSNBSchema']),
  seoData: PropTypes.object,
  meta: PropTypes.object,
  link: PropTypes.object,
  VAP: PropTypes.bool
};

SeoTags.defaultProps = {
  type: '',
  VAP: false
};

export default SeoTags;
